import React, { useState, useEffect } from "react";

export default function AVERAGEStest(props) {
  const correctAnswers = [2, 2, 1, 2, 2, 1, 2, 3, 1, 1, 2, 1, 0, 2, 3, 0, 2, 3, 2, 2, 1, 2, 1, 2, 1];
  const que = {
    q1: {
      string: "1. The average of 4, 6, 8, and 10 is:",
      options: ["6", "7", "8", "9"],
      ans: 2
    },
    q2: {
      string: "2. The average of five numbers is 20. If one number is removed, the average becomes 18. What is the removed number?",
      options: ["20", "25", "30", "35"],
      ans: 2
    },
    q3: {
      string: "3. The average of the first five odd numbers is:",
      options: ["3", "5", "7", "9"],
      ans: 1
    },
    q4: {
      string: "4. The average of three consecutive even numbers is 18. What is the largest of these numbers?",
      options: ["16", "18", "20", "22"],
      ans: 2
    },
    q5: {
      string: "5. The average of 8, 12, and 20 is:",
      options: ["12", "13", "15", "16"],
      ans: 2
    },
    q6: {
      string: "6. The average of six numbers is 42. If one of the numbers is 72, what is the average of the other five numbers?",
      options: ["32", "35", "38", "40"],
      ans: 1
    },
    q7: {
      string: "7. The average of four numbers is 50. If three of the numbers are 45, 55, and 60, what is the fourth number?",
      options: ["30", "35", "40", "45"],
      ans: 2
    },
    q8: {
      string: "8. The average of 2, 4, 6, 8, and 10 is:",
      options: ["4", "5", "6", "7"],
      ans: 3
    },
    q9: {
      string: "9. The average of seven numbers is 14. If one of the numbers is 21, what is the average of the other six numbers?",
      options: ["12", "13", "14", "15"],
      ans: 1
    },
    q10: {
      string: "10. The average of five consecutive numbers is 9. What is the smallest of these numbers?",
      options: ["5", "6", "7", "8"],
      ans: 1
    },
    q11: {
      string: "11. The average of the first ten natural numbers is:",
      options: ["4.5", "5", "5.5", "6"],
      ans: 2
    },
    q12: {
      string: "12. The average of 25, 30, 35, 40, and 45 is:",
      options: ["30", "35", "40", "45"],
      ans: 1
    },
    q13: {
      string: "13. The average of three numbers is 10. The first number is 8, and the second number is 12. What is the third number?",
      options: ["8", "10", "12", "14"],
      ans: 0
    },
    q14: {
      string: "14. The average age of 30 students in a class is 14. If the teacher's age is included, the average age becomes 15. What is the teacher's age?",
      options: ["44", "45", "46", "47"],
      ans: 2
    },
    q15: {
      string: "15. The average of 11, 15, and 19 is:",
      options: ["12", "13", "14", "15"],
      ans: 3
    },
    q16: {
      string: "16. The average of four consecutive odd numbers is 24. What is the smallest of these numbers?",
      options: ["21", "23", "25", "27"],
      ans: 0
    },
    q17: {
      string: "17. The average of five numbers is 7. If one number is excluded, the average becomes 6. What is the excluded number?",
      options: ["10", "11", "12", "13"],
      ans: 2
    },
    q18: {
      string: "18. The average of 9, 12, and 15 is:",
      options: ["10", "11", "12", "13"],
      ans: 3
    },
    q19: {
      string: "19. The average of five numbers is 18. If one number is added, the average becomes 20. What is the added number?",
      options: ["28", "30", "32", "34"],
      ans: 2
    },
    q20: {
      string: "20. The average of three consecutive multiples of 3 is 12. What is the largest of these numbers?",
      options: ["9", "12", "15", "18"],
      ans: 2
    },
    q21: {
      string: "21. The average of 16, 18, 20, and 22 is:",
      options: ["18", "19", "20", "21"],
      ans: 1
    },
    q22: {
      string: "22. The average of five numbers is 24. If one number is 30, what is the average of the other four numbers?",
      options: ["21", "22", "23", "24"],
      ans: 2
    },
    q23: {
      string: "23. The average of the first six multiples of 5 is:",
      options: ["15", "20", "25", "30"],
      ans: 1
    },
    q24: {
      string: "24. The average of four consecutive even numbers is 26. What is the smallest of these numbers?",
      options: ["20", "22", "24", "26"],
      ans: 2
    },
    q25: {
      string: "25. The average of 10, 20, 30, and 40 is:",
      options: ["20", "25", "30", "35"],
      ans: 1
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>APTITUDE <span>AVERAGES</span> </h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
